// Native & external imports
import { Pipe, PipeTransform, inject } from "@angular/core";
// Services
import { AppLocalization } from '@icamppro-customer-portal/shared/cmp-base';

@Pipe({ name: "localecurrency", standalone: false })
export class LocaleCurrencyPipe implements PipeTransform {
  private _appLocalization = inject(AppLocalization);

  transform(
    value: string | number,
    signStyle: "standard" | "accounting" = "standard",
  ): string {
    if (typeof value === "string") {
      value = this._appLocalization.client.stringToNumber(value) || 0;
    }
    return this._appLocalization.client.formatCurrency(value, null, {
      currencySign: signStyle,
    });
  }
}
